import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {BrowserModule} from '@angular/platform-browser';
import {CoreModule} from '../core/core.module';
import {HydraErrorPageComponent} from '../oauth/components/hydra-error-page/hydra-error-page.component';
import {FooterComponent} from './components/footer/footer.component';
import {SidebarComponent} from './components/sidebar/sidebar.component';
import {MaintenanceNoticeComponent} from './containers/maintenance-notice/maintenance-notice.component';
import {SamlErrorPageComponent} from './containers/saml-error-page/saml-error-page.component';
import {UasPortalComponent} from './containers/uas-portal.component';
import {UasPortalRoutingModule} from './uas-portal-routing.module';
import {DisableNoticeComponent} from './containers/disable-notice/disable-notice.component';
import {InfoSliderComponent} from './components/info-slider/info-slider.component';

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    FormsModule,
    CoreModule,
    UasPortalRoutingModule,
    HydraErrorPageComponent,
    SidebarComponent,
    FooterComponent,
    UasPortalComponent,
    MaintenanceNoticeComponent,
    SamlErrorPageComponent,
    DisableNoticeComponent,
    InfoSliderComponent,
  ],
  exports: [],
  providers: [],
})
export class UasPortalModule {
}
